/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Invite_Code_InvalidInputs */

const en_common_sign_invite_code_invalid = /** @type {(inputs: Common_Sign_Invite_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid invite code`)
};

/**
* | output |
* | --- |
* | "Invalid invite code" |
*
* @param {Common_Sign_Invite_Code_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_invite_code_invalid = /** @type {((inputs?: Common_Sign_Invite_Code_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Invite_Code_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_invite_code_invalid(inputs)
});
export { common_sign_invite_code_invalid as "common.sign.invite_code_invalid" }